import React, { useState, useEffect, useMemo,useRef } from "react";
import { useHistory,useLocation,Link  } from "react-router-dom";
import { submitVideo } from "network/ApiAxios";
import {UncontrolledCollapse,NavbarBrand,Navbar,Container,Row,Col,Button} from "reactstrap";
import VideoRecorder from 'react-video-recorder'
import axios from "axios";

function NextFaseVideoUpload() {
    const [userID, setuserID] = useState('');
    const [recordDone, setRecordDone] = useState(false);
    const [alreadySubmited, setAlreadySubmited] = useState(false);
    let { search } = useLocation(); //get referer from url
    //const uploadDiv = useRef(null)

    useEffect(() => {
        //uploadDiv.current.children[0].style.minHeight = "70px";
        //uploadDiv.current.children[0].style.backgroundColor = "transparent";
        //uploadDiv.current.children[0].children[1].children[0].style.background = "red";
        const path = 'https://celebrationjump.com/userfiles/cvs/videoCV-'+ userID + '.webm'
        axios
        .get(path)
        .then((data) => {
            if(data.headers['content-type']== "video/webm"){
                setAlreadySubmited(true)
            }else{
                setAlreadySubmited(false)
            }
            return true;
        })
        .catch(() => {
            setAlreadySubmited(true)
            return false;
        });
    }, []);

    const referer=useMemo(() => {
        new URLSearchParams(search)
        setuserID(search.split('=')[1])
        return search.split('=')[1]
    }, [search])

    const handleSubmitVideo = async(videoData)=>{
        const resp = await submitVideo(videoData)
        if(resp.data.success){
            setRecordDone(true)
        }else{
            alert('Something went wrong with your upload!')
        }
    }

  return (
    <>
      <Navbar
        className="navbar-top navbar-horizontal navbar-blue"
        expand="md"
        style={{
          background: "linear-gradient(87deg, #11cdef 0, #1171ef 100%)",
        }}
      >
        <Container className="px-4 ">
          <NavbarBrand>
            <img
              alt="..s."
              src={require("../../assets/img/brand/argon-react.png").default}
              style={{ height: "50px" }}
            />
          </NavbarBrand>
          <button className="navbar-toggler" id="navbar-collapse-main">
            <span className="navbar-toggler-icon" />
          </button>
          <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <img
                    alt="..."
                    src={require("../../assets/img/brand/argon-react.png").default}
                  />
                </Col>
                <Col className="collapse-close" xs="6">
                  <button className="navbar-toggler" id="navbar-collapse-main">
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
        {!alreadySubmited ? <Container className="mt-6" style={{height:'75vh'}}>
            {recordDone && <Row className=" d-flex justify-content-center" style={{zIndex:1,position:'absolute',marginTop:'50vh',marginLeft:'33%'}}>
                <Link to='/'><Button className=" btn-info" >Submit</Button></Link>
            </Row>}
            {userID && <>
                          {/*<div style={{width:'130px'}} ref={uploadDiv} className="mb-3">
                            <VideoRecorder
                                onRecordingComplete={async(videoBlob) => {
                                  let fd = new FormData();
                                  fd.append('userId', userID)
                                  fd.append('data', videoBlob)
                                  handleSubmitVideo(fd)
                                }}
                                
                                chunkSize={250}
                                constraints={{
                                  audio: true,
                                  video: true
                                }}
                                showReplayControls
                                useVideoInput
                            />
                        </div>*/}
                        <VideoRecorder
                            onRecordingComplete={async(videoBlob) => {
                                let fd = new FormData();
                                fd.append('userId', userID)
                                fd.append('data', videoBlob)
                                handleSubmitVideo(fd)
                            }}
                            chunkSize={250}
                            constraints={{
                                audio: true,
                                video: true
                              }}
                            showReplayControls
                        />
                        
            </>}
        
        </Container> :
        <Container className=" d-flex justify-content-center align-content-center align-middle" style={{height:'70vh'}}>
            <Row className=" d-flex justify-content-center align-content-center align-middle">
                <h1>Your video has been submited</h1>
            </Row>
        </Container>}
    </>
  )
}

export default NextFaseVideoUpload